import { useLocation } from "react-router-dom";

// Engleza e la adresele de bază (/servicii), româna sub /ro (/ro/servicii).
// Paginile traduse; restul (blog, articole, pagini vechi) există într-o singură limbă.
export const TRANSLATED_PATHS = [
  "/",
  "/servicii",
  "/capabilitati",
  "/agentii-partenere",
  "/contact",
];

export const langFromPath = (pathname) =>
  pathname === "/ro" || pathname.startsWith("/ro/") ? "ro" : "en";

// Calea paginii fără prefixul de limbă: "/ro/servicii" -> "/servicii", "/ro" -> "/"
export const basePath = (pathname) => {
  if (langFromPath(pathname) === "en") return pathname;
  return pathname.slice(3) || "/";
};

// Calea unei pagini într-o limbă: ("/servicii", "ro") -> "/ro/servicii"
export const pathForLang = (path, lang) => {
  if (lang === "en") return path;
  return path === "/" ? "/ro" : `/ro${path}`;
};

// Pagina echivalentă în cealaltă limbă; paginile netraduse duc la homepage
export const switchLangPath = (pathname, targetLang) => {
  const base = basePath(pathname.replace(/\/+$/, "") || "/");
  return pathForLang(TRANSLATED_PATHS.includes(base) ? base : "/", targetLang);
};

export const useLang = () => langFromPath(useLocation().pathname);

// Link intern în limba paginii curente: localPath("/servicii")
export const useLocalPath = () => {
  const lang = useLang();
  return (path) => (TRANSLATED_PATHS.includes(path) ? pathForLang(path, lang) : path);
};

// Textele unei componente în limba curentă: useText({ en: {...}, ro: {...} })
export const useText = (texts) => texts[useLang()];

// Pentru componentele mari: textul englez rămâne în cod, t("Our Services"),
// iar RO = { "Our Services": "Serviciile noastre", ... } dă traducerea.
// Un text fără traducere apare în engleză.
export const useT = (ro) => {
  const lang = useLang();
  return (text) => (lang === "ro" && ro[text]) || text;
};
